import { cn } from '@/utilities/ui'
import { type ClassValue } from 'clsx'
import NextLink from 'next/link'

interface Props {
    className?: ClassValue
}

export function Copyright({ className }: Props) {
    return (
        <NextLink className={cn('block text-sm', className)} href='https://www.quartzmedianetwork.com/'>
            <span>© {new Date().getFullYear()} Quartz Media Network. All Rights Reserved.</span>
        </NextLink>
    )
}
